import { Typography } from '@material-tailwind/react';
import LoginButton from 'src/components/molecules/buttons/login-button/login-button';

function LandingView() {
  return (
    <div className="max-w-sm w-full mx-auto">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg px-8 py-8">
        <div className="text-center mb-12">
          <img
            src="/logos/logo-full-light.svg"
            alt="Comos Logo"
            className="w-[12rem] mx-auto"
          />
        </div>

        <Typography
          variant="paragraph"
          className="text-secondary-600 text-center mb-8"
        >
          Tus comunicaciones en un sólo lugar
        </Typography>

        <LoginButton
          size="lg"
          className="w-full bg-primary-600 hover:bg-primary-700 shadow-lg"
        />
      </div>
    </div>
  );
}

export default LandingView;
